import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React, { useState, useEffect } from "react";
import {
  CustomButton,
  DocumentLabels,
  SelectSpan,
  StyledCard,
  StyledOutlineButton,
  VendorCardLabel,
} from "../../vendorRegistration/components/StepMain";
import {
  CustomTableContainer,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import {
  Super,
  VendorCardSubTitle,
} from "../../vendorRegistration/components/steps/cardTrial";
import { VendorCardTitle } from "../../vendorRegistration/components/steps/vendorReg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import item_excel from "../../../assets/PRItemUpload.xlsx";
import { useForm } from "react-hook-form";
import { styled } from "@mui/system";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  getMaterials,
  resetMatrials,
  getAdminPrDetails,
  editPr,
  excelToPrItemDetails,
} from "../redux/adminPrsSlice";
import {
  getApprovers,
  getPersons,
  getPrWorkflowDetails,
} from "../../workflows/redux/userWorkflowsSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { history } from "../../../app/history";
import LocalStorage from "../../../utilities/localStorage";
import { Company } from "../../../CONSTANTS";
// import AutoComplate from "../../../common/sharedComponents/AutoComplate";
import { getCompanyListForPr } from "../../adminTable/redux/sendLinkSlice";
import GlobalAutocomplete from "../../../common/sharedComponents/AutoComplate";
import { getPurchasePoints } from "../../company/redux/companySlice";
import { useParams } from "react-router-dom";
import { GetAppRounded } from "@mui/icons-material";
import { message } from "antd";

const Input = styled("input")({
  display: "none",
});

function AdminEditPrsContent() {
  const dispatch = useDispatch();
  const { materials, excelToPrItemDetailsLoading } = useSelector(
    (state) => state.adminPrs,
  );
  const { approvers, persons, pr_workflow_details } = useSelector(
    (state) => state.userWorkflows,
  );
  const { companyListForPr, loading: apiLoader } = useSelector(
    (state) => state.sendInvitationLink,
  );
  const { purchasePointList } = useSelector((state) => state.company);
  const [datevalue, setDatevalue] = useState(Date);
  const [prDoc, setPrDoc] = useState("");
  const [supportingDoc, setSupportingDoc] = useState([{ supporting_docs: "" }]);
  const [existingDoc, setExistingDoc] = useState([]);
  const [items, setItems] = useState([]);

  const [itemswf, setItemswf] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [preDefinedWorkflowSteps, setPreDefinedWorkflowSteps] = useState([]);
  const [selection, setSelection] = useState("person");
  const [wfSelection, setWfSelection] = useState("predefined");
  const [expenseType, setExpenseType] = useState("opex");
  // const [selectedItemNames, setSelectedItemNames] = useState([]);
  const [prItemDoc, setPrItemDoc] = useState(null);

  const item_list_wf = selection === "role" ? approvers : persons;

  const user = LocalStorage.getItem("tata_login_user");
  const clientId = LocalStorage.getItem("client")?.id;
  const roles = user.roles;
  const role = roles[0];
  const params = useParams();
  const pr_id = params.prid;

  const [shippingAddress, setShippingAddress] = useState(
    clientId === 5
      ? "JASLOK HOSPITAL & RESEARCH CENTRE 15 DR G. DESHMUKH MARG, MUMBAI -400026"
      : "",
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    reset,
    watch,
  } = useForm();
  // const watch1 = watch();
  // console.log("watch1", watch1);
  const getData = () => {
    dispatch(getApprovers());
    dispatch(getPersons());
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(getAdminPrDetails(pr_id)).then((res) => {
      if (res.payload.success) {
        reset({
          company_id: {
            key: res.payload.data.company_id,
            value: res.payload.data.Company?.company_name,
          },
          desired_delivery_date: res.payload.data.desired_delivery_date, // Set initial value
          billing_address: res.payload.data.billing_address,
          preferred_supplier: res.payload.data.preferred_supplier,
          reason_of_purchase: res.payload.data.reason_of_purchase,
          urgency_level: res.payload.data.urgency_level,
          remarks: res.payload.data.remarks,
        });
        const formattedDate = new Date(res.payload.data.desired_delivery_date)
          .toISOString()
          .split("T")[0];
        setDatevalue(formattedDate); // Ensure 'YYYY-MM-DD' format
        setShippingAddress(res.payload.data.shipping_address);
        console.log("res.payload.data", res.payload.data?.Pr_documents);

        setExistingDoc(res?.payload?.data?.Pr_documents);
        setItems(
          res.payload?.data?.item_list?.map((item, index) => {
            return {
              quantity: item?.quantity,
              unit_of_measurement: item?.uom,
              frequency: item?.frequency,
              item_name: {
                key: item?.material_masters_id,
                value: item?.item_name,
                MaterialCode: item?.item_code,
                LongDescription: item?.item_description,
                UOM: item?.UOM,
              },
              purpose: item?.purpose,
            };
          }),
        );
      }
    });
    // eslint-disable-next-line
  }, []);
  console.log("existingDoc", existingDoc);

  // Watch the company_id from react-hook-form
  const companyId = watch("company_id")?.key;

  useEffect(() => {
    if (companyId) {
      console.log("Calling getPrWorkflowDetails with", companyId);
      dispatch(getPrWorkflowDetails(companyId));
      dispatch(getPurchasePoints(0));
    }
  }, [companyId, dispatch]);

  useEffect(() => {
    dispatch(getCompanyListForPr());
    // eslint-disable-next-line
  }, [dispatch]);

  const handleClearFc = (type, rowIndex) => {
    dispatch(
      getMaterials({
        search_by: type,
        search_key: "",
      }),
    );
    const updatedItems = [...items];

    if (updatedItems[rowIndex]) {
      updatedItems[rowIndex].item_name = null;
    }
    setItems(updatedItems);
  };
  const handlePrItemExcel = (e) => {
    setPrItemDoc(e.target.files[0]);
  };
  const handleClearPrItemExcel = (e) => {
    setPrItemDoc(null);
  };
  const handleOnchange = (e) => {
    let workflow_id = e.target.value;
    let matchedWorkflow = pr_workflow_details.find(
      (workflow) => workflow.id === workflow_id,
    );
    setPreDefinedWorkflowSteps(matchedWorkflow?.steps);
  };

  const handleShippingChange = (event) => {
    setShippingAddress(event.target.value);
    setValue("shipping_address", event.target.value);
  };

  const handleSelectionChange = (event) => {
    setSelection(event.target.value);
  };

  const handleWfsSelectionChange = (event) => {
    setWfSelection(event.target.value);
    if (event.target.value === "manual") {
      setPreDefinedWorkflowSteps([]);
    }
  };

  const handleExpenseSelectionChange = (event) => {
    setExpenseType(event.target.value);
  };

  const handleOnClick = () => {
    let docsCopy = [...supportingDoc];

    docsCopy.push({
      supporting_docs: "",
    });

    setSupportingDoc(docsCopy);
  };

  const handleinvdate = (e) => {
    setDatevalue(e.target.value);
  };

  const handleAddItem = () => {
    const newItem = {
      quantity: 0,
      unit_of_measurement: "",
      frequency: "",
      item_name: "",
      purpose: "",
    };

    setItems([...items, newItem]);
    dispatch(resetMatrials());
  };

  const handleAddItemWF = () => {
    let newItem;
    if (selection === "role") {
      newItem = {
        role_name: "",
      };
    } else {
      newItem = {
        contact_person_email: "",
      };
    }

    setItemswf([...itemswf, newItem]);
  };

  const handleRemove = (e, i) => {
    const uploadeddocs = supportingDoc?.filter((doc, doc_i) => doc_i !== i);
    setSupportingDoc(uploadeddocs);
  };

  const handleRemoveItem = (index) => {
    setItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleRemoveItemWF = (index) => {
    const updatedItems = [...itemswf];
    updatedItems.splice(index, 1);

    // Remove the corresponding email from the selectedEmails array
    setSelectedEmails((prevSelectedEmails) => {
      const newSelectedEmails = [...prevSelectedEmails];
      newSelectedEmails.splice(index, 1); // Remove the email at the same index
      return newSelectedEmails;
    });

    setItemswf(updatedItems);
  };

  const handleInputChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };

  const handleInputChangewf = (index, field, value) => {
    const updatedItems = [...itemswf];
    updatedItems[index][field] = value;

    // Update selected emails array
    setSelectedEmails((prevSelectedEmails) => {
      const newSelectedEmails = [...prevSelectedEmails];
      newSelectedEmails[index] = value;
      return newSelectedEmails;
    });

    setItemswf(updatedItems);
  };

  const handlechangeDoc = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    setSupportingDoc((prevDocs) => {
      const newDocValues = [...prevDocs];

      newDocValues[index] = { supporting_docs: file };

      return newDocValues;
    });
  };

  const handleclearDoc = (e, index) => {
    const newDocValues = supportingDoc?.filter((doc, doc_i) => doc_i !== index);
    if (newDocValues?.length) {
      setSupportingDoc(newDocValues);
    } else {
      setSupportingDoc([{ supporting_docs: "" }]);
    }
  };
  console.log(supportingDoc);
  const handleExistingDocClear = (index) => {
    const newArr = existingDoc?.filter((doc, doc_i) => doc_i !== index);
    setExistingDoc(newArr);
  };
  // console.log("existingDoc", companyListForPr);

  const handleSave = (data) => {
    setLoading(true);
    let pr_details = [
      {
        pr_id: pr_id,
        company_id: data?.company_id?.key,
        pr_number: data.pr_number,
        pr_amount: parseFloat(data.pr_amount),
        desired_delivery_date: datevalue,
        shipping_address:
          clientId === 5 || clientId === 3
            ? shippingAddress
            : data.shipping_address,
        billing_address: data.billing_address,
        items: items,
        preferred_supplier: data.preferred_supplier,
        reason_of_purchase: data.reason_of_purchase,
        urgency_level: watch("urgency_level"),
        remarks: data.remarks,
        approvers: wfSelection === "manual" ? itemswf : null,
        selection: wfSelection === "manual" ? selection : null,
        pr_workflow_details:
          clientId !== 5
            ? wfSelection !== "manual"
              ? preDefinedWorkflowSteps
              : null
            : null,

        wfSelection: clientId !== 5 ? wfSelection : "pre-defined", //  Jaslok has only pre-defined wf
        expenseType: expenseType,
        cpp_id: data.cpp_id,
        existing_supporting_documents: existingDoc?.map(
          (item) => item?.supporting_documents,
        ),
      },
    ];

    var formData = new FormData();
    formData.append("data", JSON.stringify(pr_details));
    formData.append("pr_document", prDoc);

    for (let i = 0; i < supportingDoc?.length; i++) {
      formData.append(
        "supporting_documents",
        supportingDoc[i]?.supporting_docs,
      );
    }
    dispatch(editPr(formData)).then((response) => {
      if (response?.payload?.success) {
        setLoading(false);
        history.push("/app/prs-list/assigned");
      } else {
        setLoading(false);
      }
    });
  };

  const handleUploadFc = () => {
    if (prItemDoc) {
      var formData = new FormData();
      formData.append("excel_items", prItemDoc);
      try {
        dispatch(excelToPrItemDetails(formData)).then((res) => {
          if (res.payload.success) {
            const newArray = res?.payload?.data?.map((item) => ({
              frequency: item?.frequency,
              purpose: item?.purpose,
              quantity: item?.quantity,
              unit_of_measurement: item?.uom,
              item_name: {
                LongDescription: item?.item_description,
                MaterialCode: item?.item_code,
                UOM: item?.uom,
                value: item?.item_name,
                key: item?.id,
              },
            }));
            const filteredArray = newArray?.filter(
              (sub_item) =>
                !items?.some(
                  (item) => item?.item_name?.key === sub_item?.item_name?.key,
                ),
            );
            setItems([...items, ...filteredArray]);
            setPrItemDoc(null);
          }
        });
      } catch (error) {
        message.error(error);
      }
    } else {
      message.error("Please Upload File");
    }
  };
  return (
    <>
      {apiLoader ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <form onSubmit={handleSubmit(handleSave)}>
          <StyledCard>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <VendorCardTitle style={{ paddingBottom: "0" }}>
                    Main Details
                  </VendorCardTitle>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={3}>
                <Grid item md={6}>
                  <VendorCardLabel>
                    Select {Company} <Super>*</Super>
                  </VendorCardLabel>
                  <GlobalAutocomplete
                    name="company_id"
                    control={control}
                    options={
                      companyListForPr?.flatMap((el) => {
                        return {
                          key: el.id,
                          value: el?.company_name,
                        };
                      }) || []
                    }
                    placeholder={`Select ${Company.toLocaleLowerCase()}`}
                    rules={{
                      required: `${Company.toLocaleLowerCase()} is required`,
                    }}
                    isMultiple={false}
                    onSelect={() => {
                      dispatch(getPrWorkflowDetails(watch()?.company_id?.key));
                    }}
                  />
                </Grid>
                {/* <Grid item md={6}>
                  <VendorCardLabel>
                    PR Number<Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter PR number"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="pr_number"
                    {...register("pr_number", {
                      required: "Please enter PR number",
                    })}
                    error={Boolean(errors?.pr_number)}
                    helperText={errors?.pr_number?.message}
                  />
                </Grid> */}
                {clientId === 5 ? (
                  <>
                    <Grid item md={6}>
                      <FormControl
                        variant="standard"
                        style={{ width: "100%" }}
                        error={Boolean(errors?.cpp_id)}
                      >
                        <VendorCardLabel>
                          Purchase Point <Super>*</Super>
                        </VendorCardLabel>
                        <Select
                          sx={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "14px",
                          }}
                          displayEmpty
                          defaultValue=""
                          IconComponent={() => (
                            <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                          )}
                          labelId="demo-simple-select-standard-label"
                          id="cpp_id"
                          name="cpp_id"
                          error={Boolean(errors?.cpp_id)}
                          {...register("cpp_id", {
                            required: "Please select purchase point",
                          })}
                        >
                          <MenuItem value="">
                            <span
                              style={{ fontSize: "14px", color: "#A5A5BA" }}
                            >
                              Select Purchase Point
                            </span>
                          </MenuItem>
                          {purchasePointList.map((item, index) => (
                            <MenuItem value={item.id} key={index}>
                              <SelectSpan>
                                {item["PurchasePointMaster.purchase_point"]}
                              </SelectSpan>
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error>
                          {errors.cpp_id?.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </>
                ) : (
                  ""
                )}
                <Grid item md={6}>
                  <FormControl variant="standard" style={{ width: "100%" }}>
                    <VendorCardLabel>
                      Desired Delivery Date<Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{
                        disableUnderline: false,
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      type="date"
                      style={{
                        width: "100%",
                        paddingTop: "3px",
                        borderBottom: errors?.desired_delivery_date
                          ? "0"
                          : "1px solid lightgray",
                      }}
                      name="desired_delivery_date"
                      placeholder="Select desired delivery date"
                      {...register("desired_delivery_date", {
                        required: "Please select desired delivery date",
                      })}
                      value={datevalue} // Validate the value
                      onChange={(e) => handleinvdate(e)}
                      inputProps={{
                        min: new Date().toISOString().split("T")[0], // Set the minimum date
                      }}
                      error={Boolean(errors?.desired_delivery_date)}
                      helperText={errors?.desired_delivery_date?.message}
                    />
                  </FormControl>
                </Grid>
                {clientId !== 5 ? (
                  ""
                ) : (
                  <Grid item md={6}>
                    <VendorCardLabel>
                      PR Amount <Super>*</Super>{" "}
                    </VendorCardLabel>
                    <TextField
                      type="number"
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      placeholder="Enter PR Amount"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="pr_amount"
                      {...register("pr_amount", {
                        required: "Please Enter PR Amount",
                      })}
                      error={Boolean(errors?.pr_amount)}
                      helperText={errors?.pr_amount?.message}
                    />
                  </Grid>
                )}
              </Grid>
              <br />
              {clientId === 5 ? (
                <>
                  <VendorCardLabel>Select the type of expense</VendorCardLabel>
                  <Grid container spacing={1}>
                    <Grid item md={12}>
                      <RadioGroup
                        value={expenseType}
                        onChange={handleExpenseSelectionChange}
                        row
                      >
                        <FormControlLabel
                          value="capex"
                          control={<Radio />}
                          label={
                            <Typography
                              variant="body1"
                              style={{
                                fontSize: "0.9rem",
                                fontFamily: "Arial, sans-serif",
                              }}
                            >
                              CapEx
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value="opex"
                          control={<Radio />}
                          label={
                            <Typography
                              variant="body1"
                              style={{
                                fontSize: "0.9rem",
                                fontFamily: "Arial, sans-serif",
                              }}
                            >
                              OpEx
                            </Typography>
                          }
                        />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                  <br />
                </>
              ) : (
                ""
              )}

              <Grid container spacing={1}>
                <Grid item md={12}>
                  <VendorCardLabel>Shipping Address</VendorCardLabel>

                  <TextField
                    multiline
                    rows={3}
                    placeholder="Enter shipping address"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      fontSize: "8px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                    value={shippingAddress}
                    onChange={handleShippingChange}
                    disabled={clientId === 5}
                    name="shipping_address"
                    inputRef={register("shipping_address", { required: false })}
                  />
                </Grid>
              </Grid>
              <br />
              {clientId !== 5 ? (
                <>
                  <Grid container spacing={1}>
                    <Grid item md={12}>
                      <VendorCardLabel>Billing Address</VendorCardLabel>
                      <TextField
                        multiline
                        rows={3}
                        placeholder="Enter billing address"
                        style={{
                          width: "100%",
                          paddingTop: "3px",
                          fontSize: "8px",
                          fontFamily: "var(--font-family-reg)",
                        }}
                        name="billing_address"
                        value={watch("billing_address")}
                        {...register("billing_address", {
                          required: false,
                        })}
                        onChange={(e) =>
                          setValue("billing_address", e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>{" "}
                  <br />
                </>
              ) : (
                ""
              )}

              <>
                <br />
                <Grid container spacing={2} justifyContent="space-between">
                  <Grid item md={6}>
                    <VendorCardTitle style={{ paddingBottom: "0" }}>
                      Item Details
                    </VendorCardTitle>
                    <VendorCardSubTitle style={{ marginTop: "0" }}>
                      Upload items Using Excel
                    </VendorCardSubTitle>
                  </Grid>
                  <Grid item>
                    <Box display="flex" alignItems="center" gap={2}>
                      <a
                        href={item_excel}
                        download
                        style={{ textDecoration: "none" }}
                      >
                        {/* <Button
                        variant="contained"
                        color="primary"
                        startIcon={<GetAppRounded />}
                        sx={{
                          textTransform: "none",
                          fontSize: "0.875rem",
                          borderRadius: 2,
                        }}
                      >
                        Download Excel
                      </Button> */}
                        <Tooltip title="Download Template">
                          <IconButton
                            sx={{
                              width: 50,
                              height: 50,
                              color: "primary.main",
                            }}
                          >
                            <GetAppRounded
                              sx={{
                                width: 35,
                                height: 35,
                                color: "primary.main",
                              }}
                              fontSize="small"
                            />
                          </IconButton>
                        </Tooltip>
                      </a>
                      <FormControl variant="standard">
                        {prItemDoc?.name ? (
                          <span
                            style={{
                              color: "#4945FF",
                              fontSize: "13px",
                              fontFamily: "var(--font-family-reg)",
                            }}
                          >
                            <Chip
                              style={{
                                width: "150px",
                                color: "#4945FF",
                                margin: "5px",
                                borderRadius: "5px",
                                border: "1px solid #D9D8FF",
                                background: "#F0F0FF",
                              }}
                              label={prItemDoc?.name}
                              value={prItemDoc?.name}
                              name="chips"
                            />
                            <HighlightOffIcon
                              sx={{ color: "#4945FF", paddingBottom: "2px" }}
                              fontSize="medium"
                              onClick={(e) => handleClearPrItemExcel(e)}
                            />
                          </span>
                        ) : (
                          <label>
                            <Input
                              accept="*"
                              id="pr_item_excel"
                              onChange={(e) => handlePrItemExcel(e)}
                              type="file"
                              sx={{ display: "none" }}
                            />
                            <Button
                              variant="outlined"
                              component="span"
                              sx={{
                                textTransform: "none",
                                fontSize: "0.875rem",
                                borderRadius: 2,
                                borderColor: "primary.main",
                                color: "primary.main",
                              }}
                            >
                              Upload
                            </Button>
                          </label>
                        )}
                      </FormControl>
                      {prItemDoc && (
                        <LoadingButton
                          variant="contained"
                          color="primary"
                          // startIcon={<GetAppRounded />}
                          sx={{
                            textTransform: "none",
                            fontSize: "0.875rem",
                            borderRadius: 2,
                          }}
                          loading={excelToPrItemDetailsLoading}
                          onClick={handleUploadFc}
                        >
                          Upload
                        </LoadingButton>
                      )}
                    </Box>
                  </Grid>
                </Grid>
                <CustomTableContainer component={Card}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        style={{
                          backgroundColor: "#e1ebfa",
                        }}
                      >
                        <TableCell>
                          <TableHeaderFont>Action</TableHeaderFont>
                        </TableCell>
                        <TableCell>
                          <TableHeaderFont>Sr. No.</TableHeaderFont>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <TableHeaderFont>Item Code</TableHeaderFont>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <TableHeaderFont>Item Name</TableHeaderFont>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <TableHeaderFont>Item Description</TableHeaderFont>
                        </TableCell>
                        <TableCell>
                          <TableHeaderFont>Req Qty</TableHeaderFont>
                        </TableCell>
                        <TableCell>
                          <TableHeaderFont>UOM</TableHeaderFont>
                        </TableCell>
                        <TableCell>
                          <TableHeaderFont>Frequency</TableHeaderFont>
                        </TableCell>
                        <TableCell>
                          <TableHeaderFont>
                            Purpose & Justification
                          </TableHeaderFont>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {excelToPrItemDetailsLoading ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    ) : (
                      <TableBody>
                        {items.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              backgroundColor: "#fafcff",
                            }}
                          >
                            <TableCell>
                              <CustomButton
                                className="invoiceErrbutn"
                                color="error"
                                variant="outlined"
                                size="small"
                                onClick={() => handleRemoveItem(index)}
                                style={{
                                  marginLeft: "3px ",
                                  textAlign: "center",
                                }}
                              >
                                Remove
                              </CustomButton>
                            </TableCell>
                            <TableCell
                              style={{
                                fontFamily: "var(--font-family-reg)",
                                fontSize: "12px",
                                textAlign: "center",
                              }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell>
                              <Autocomplete
                                options={materials.map((el) => ({
                                  key: el.id,
                                  value: el.Description,
                                  MaterialCode: el?.MaterialCode,
                                  LongDescription: el?.LongDescription,
                                  UOM: el?.UOM,
                                }))}
                                value={item?.item_name || null}
                                getOptionLabel={(option) =>
                                  option.MaterialCode || ""
                                }
                                getOptionDisabled={(option) =>
                                  items?.some(
                                    (selected) =>
                                      selected?.item_name?.MaterialCode ===
                                      option?.MaterialCode,
                                  )
                                }
                                onChange={(_, selectedOption) => {
                                  if (selectedOption) {
                                    handleInputChange(
                                      index,
                                      "item_name",
                                      selectedOption,
                                    );
                                  }
                                  if (!selectedOption) {
                                    handleClearFc("item_name", index);
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    // label="Type Item Name"
                                    variant="outlined"
                                    required
                                    onChange={(e) => {
                                      if (e.target.value.length >= 4) {
                                        dispatch(
                                          getMaterials({
                                            search_by: "item_code",
                                            search_key: e.target.value,
                                          }),
                                        );
                                      }
                                    }}
                                    sx={{
                                      width: "300px",
                                      fontWeight: "fontWeightLight",
                                      "& .MuiAutocomplete-inputRoot": {
                                        padding: "2px 4px",
                                        "& .MuiOutlinedInput-input": {
                                          padding: "2px 4px",
                                          fontSize: "10px",
                                        },
                                      },
                                      "& .MuiAutocomplete-input": {
                                        fontSize: "10px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        top: "-4px",
                                        fontSize: "12px",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell>
                              <Autocomplete
                                options={materials.map((el) => ({
                                  key: el.id,
                                  value: el.Description,
                                  MaterialCode: el?.MaterialCode,
                                  LongDescription: el?.LongDescription,
                                  UOM: el?.UOM,
                                }))}
                                value={item?.item_name || null}
                                getOptionLabel={(option) => option.value || ""}
                                getOptionDisabled={(option) =>
                                  items?.some(
                                    (selected) =>
                                      selected?.item_name?.value ===
                                      option?.value,
                                  )
                                }
                                onChange={(_, selectedOption) => {
                                  if (selectedOption) {
                                    handleInputChange(
                                      index,
                                      "item_name",
                                      selectedOption,
                                    );
                                  }
                                  if (!selectedOption) {
                                    handleClearFc("item_name", index);
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    // label="Type Item Name"
                                    variant="outlined"
                                    required
                                    onChange={(e) => {
                                      if (e.target.value.length >= 4) {
                                        dispatch(
                                          getMaterials({
                                            search_by: "item_name",
                                            search_key: e.target.value,
                                          }),
                                        );
                                      }
                                    }}
                                    sx={{
                                      width: "300px",
                                      fontWeight: "fontWeightLight",
                                      "& .MuiAutocomplete-inputRoot": {
                                        padding: "2px 4px",
                                        "& .MuiOutlinedInput-input": {
                                          padding: "2px 4px",
                                          fontSize: "10px",
                                        },
                                      },
                                      "& .MuiAutocomplete-input": {
                                        fontSize: "10px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        top: "-4px",
                                        fontSize: "12px",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell
                              style={{
                                fontFamily: "var(--font-family-reg)",
                                fontSize: "12px",
                                textAlign: "center",
                              }}
                            >
                              {item?.item_name?.LongDescription || "-"}
                            </TableCell>
                            <TableCell>
                              <input
                                type="number"
                                step="0.01"
                                value={item.quantity}
                                min={0}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "quantity",
                                    e.target.value,
                                  )
                                }
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "5px",
                                  borderRadius: "5px",
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: "center",
                                  width: "80px",
                                }}
                              />
                            </TableCell>

                            <TableCell
                              style={{
                                fontFamily: "var(--font-family-reg)",
                                fontSize: "12px",
                                textAlign: "center",
                              }}
                            >
                              {item?.item_name?.UOM || "-"}
                            </TableCell>
                            <TableCell>
                              <select
                                value={item.frequency}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "frequency",
                                    e.target.value,
                                  )
                                }
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "5px",
                                  borderRadius: "5px",
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  width: "80px",
                                }}
                              >
                                <option
                                  value=""
                                  style={{ fontSize: "12px", color: "#A5A5BA" }}
                                >
                                  Select frequency
                                </option>
                                <option
                                  value="annually"
                                  style={{ fontSize: "12px" }}
                                >
                                  annually
                                </option>
                                <option
                                  value="quaterly"
                                  style={{ fontSize: "12px" }}
                                >
                                  quaterly
                                </option>
                                <option
                                  value="monthly"
                                  style={{ fontSize: "12px" }}
                                >
                                  monthly
                                </option>
                                <option
                                  value="once"
                                  style={{ fontSize: "12px" }}
                                >
                                  once
                                </option>
                              </select>
                            </TableCell>
                            <TableCell>
                              <input
                                type="text"
                                value={item.purpose}
                                maxLength={1000}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "purpose",
                                    e.target.value,
                                  )
                                }
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "5px",
                                  borderRadius: "5px",
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  width: "125px",
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    )}
                  </Table>
                </CustomTableContainer>

                <CustomButton
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={handleAddItem}
                  className="invoiceErrbutn"
                  style={{ marginTop: "10px " }}
                >
                  Add Item
                </CustomButton>

                <br />
                <br />
                <br />
              </>
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <VendorCardTitle style={{ paddingBottom: "0" }}>
                    Other Details
                  </VendorCardTitle>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={3}>
                {clientId !== 5 ? (
                  <Grid item md={6}>
                    <VendorCardLabel>Preferred Supplier</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      placeholder="Enter preferred supplier"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="preferred_supplier"
                      value={watch("preferred_supplier")}
                      {...register("preferred_supplier", {
                        required: false,
                      })}
                      onChange={(e) =>
                        setValue("preferred_supplier", e.target.value)
                      }
                    />
                  </Grid>
                ) : (
                  ""
                )}

                <Grid item md={6}>
                  <VendorCardLabel>Reason of Purchase</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter reason of purchase"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="reason_of_purchase"
                    value={watch("reason_of_purchase")}
                    {...register("reason_of_purchase", {
                      required: false,
                    })}
                    onChange={(e) =>
                      setValue("reason_of_purchase", e.target.value)
                    }
                  />
                </Grid>
                <Grid item md={6}>
                  <FormControl variant="standard" style={{ width: "100%" }}>
                    <VendorCardLabel>
                      Urgency Level<Super>*</Super>
                    </VendorCardLabel>
                    <Select
                      sx={{
                        fontFamily: "var(--font-family-reg)",
                        fontSize: "14px",
                      }}
                      displayEmpty
                      IconComponent={() => (
                        <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                      )}
                      labelId="demo-simple-select-standard-label"
                      id="urgency_level"
                      name="urgency_level"
                      value={watch("urgency_level") || ""} // Use 'watch' to bind value
                      onChange={(e) =>
                        setValue("urgency_level", e.target.value)
                      } // Update value
                      error={Boolean(errors?.urgency_level)}
                      helperText={errors?.urgency_level?.message}
                    >
                      <MenuItem value="">
                        <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                          Select level
                        </span>
                      </MenuItem>
                      <MenuItem value="high">
                        <SelectSpan>High</SelectSpan>{" "}
                      </MenuItem>
                      <MenuItem value="medium">
                        <SelectSpan>Medium</SelectSpan>{" "}
                      </MenuItem>
                      <MenuItem value="low">
                        <SelectSpan>Low</SelectSpan>{" "}
                      </MenuItem>
                    </Select>
                    <FormHelperText error>
                      {errors.type?.message}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <VendorCardLabel>Remarks</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter remarks"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="remarks"
                    value={watch("remarks")}
                    {...register("remarks", {
                      required: false,
                    })}
                    onChange={(e) => setValue("remarks", e.target.value)}
                  />
                </Grid>
              </Grid>
              <br />
              <VendorCardTitle style={{ paddingBottom: "20px" }}>
                Documents
              </VendorCardTitle>

              <VendorCardSubTitle style={{ marginTop: "0" }}>
                Existing Documents
              </VendorCardSubTitle>
              {existingDoc?.length > 0 ? (
                existingDoc?.map((item, index) => (
                  <Grid container spacing={3} key={index}>
                    <Grid item xs={4}>
                      <span style={{ width: "50%" }}>
                        <DocumentLabels style={{ marginTop: "10px" }}>
                          Supporting Document
                        </DocumentLabels>
                      </span>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl variant="standard" style={{ width: "100%" }}>
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={item?.supporting_documents}
                          />
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => handleExistingDocClear(index)}
                          />
                        </span>
                      </FormControl>
                    </Grid>
                  </Grid>
                ))
              ) : (
                <div
                  style={{
                    fontSize: "12px",
                  }}
                >
                  No Existing Documents Available
                </div>
              )}
              <br />

              <VendorCardSubTitle style={{ marginTop: "0" }}>
                New Documents
              </VendorCardSubTitle>
              <Grid container spacing={3}>
                {clientId !== 5 && clientId !== 3 ? (
                  <>
                    <Grid item xs={4}>
                      <span
                        variant="outlined"
                        component="span"
                        style={{ width: "50%" }}
                      >
                        <DocumentLabels style={{ marginTop: "10px" }}>
                          Purchase Requisition Document<Super>*</Super>
                        </DocumentLabels>
                      </span>
                    </Grid>
                    <Grid item xs={3}>
                      <FormControl
                        variant="standard"
                        style={{ width: "100%" }}
                        error={Boolean(errors?.pr_document)}
                      >
                        {prDoc !== "" ? (
                          <>
                            <span
                              style={{
                                color: "#4945FF",
                                fontSize: "13px",
                                fontFamily: "var(--font-family-reg)",
                              }}
                            >
                              <Chip
                                style={{
                                  width: "150px",
                                  color: "#4945FF",
                                  margin: "5px",
                                  borderRadius: "5px",
                                  border: "1px solid #D9D8FF",
                                  background: "#F0F0FF",
                                }}
                                label={prDoc.name}
                                value={prDoc.name}
                                name="chips"
                              />
                              <HighlightOffIcon
                                sx={{ color: "#4945FF", paddingBottom: "2px" }}
                                fontSize="medium"
                                onClick={(e) => setPrDoc("")}
                              />
                            </span>
                          </>
                        ) : (
                          <label htmlFor="pr_document">
                            <Input
                              {...register("pr_document", {
                                required: "Please upload PR document",
                              })}
                              accept="*"
                              id="pr_document"
                              onChange={(e) => setPrDoc(e.target.files[0])}
                              type="file"
                            />
                            <StyledOutlineButton
                              variant="outlined"
                              component="span"
                            >
                              Upload
                            </StyledOutlineButton>
                          </label>
                        )}
                        {prDoc === "" ? (
                          <FormHelperText error>
                            {errors.pr_document?.message}
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </Grid>
                  </>
                ) : (
                  ""
                )}
              </Grid>
              {supportingDoc?.map((item, index) => (
                <>
                  <br />
                  <Grid container spacing={3} key={index}>
                    <>
                      <Grid item xs={4}>
                        <span
                          variant="outlined"
                          component="span"
                          style={{ width: "50%" }}
                        >
                          <DocumentLabels style={{ marginTop: "10px" }}>
                            Supporting Document
                          </DocumentLabels>
                        </span>
                      </Grid>
                      {item?.supporting_docs !== "" &&
                      item?.supporting_docs !== undefined ? (
                        <>
                          <Grid item xs={3}>
                            <FormControl
                              variant="standard"
                              style={{ width: "100%" }}
                            >
                              <span
                                style={{
                                  color: "#4945FF",
                                  fontSize: "13px",
                                  fontFamily: "var(--font-family-reg)",
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <Chip
                                  style={{
                                    width: "150px",
                                    color: "#4945FF",
                                    margin: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #D9D8FF",
                                    background: "#F0F0FF",
                                  }}
                                  label={item?.supporting_docs?.name}
                                  value={item?.supporting_docs?.name}
                                  name="chips"
                                />
                                <HighlightOffIcon
                                  sx={{
                                    color: "#4945FF",
                                    paddingBottom: "2px",
                                  }}
                                  fontSize="medium"
                                  onClick={(e) => handleclearDoc(e, index)}
                                />
                              </span>
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            {index === 0 ? (
                              <CustomButton
                                size="small"
                                color="primary"
                                variant="outlined"
                                onClick={handleOnClick}
                                className="invoiceErrbutn"
                              >
                                Add Document
                              </CustomButton>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={2}>
                            <FormControl
                              variant="standard"
                              style={{ width: "100%" }}
                            >
                              <label>
                                <Input
                                  accept="*"
                                  id={`supporting_doc_${index}`}
                                  onChange={(e) => handlechangeDoc(e, index)}
                                  type="file"
                                />
                                <StyledOutlineButton
                                  variant="outlined"
                                  component="span"
                                >
                                  Upload
                                </StyledOutlineButton>
                              </label>
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            {index === 0 ? (
                              <CustomButton
                                size="small"
                                color="primary"
                                variant="outlined"
                                onClick={handleOnClick}
                                className="invoiceErrbutn"
                                style={{ marginTop: "10px " }}
                              >
                                Add Document
                              </CustomButton>
                            ) : (
                              <CustomButton
                                className="invoiceErrbutn"
                                color="error"
                                variant="outlined"
                                size="small"
                                onClick={(e) => handleRemove(e, index)}
                                style={{ marginTop: "10px " }}
                              >
                                Remove
                              </CustomButton>
                            )}
                          </Grid>
                        </>
                      )}
                    </>
                  </Grid>
                </>
              ))}

              <br />
              <br />
              {clientId !== 5 ? (
                <>
                  <Grid container spacing={2}>
                    <Grid item md={6}>
                      <VendorCardTitle style={{ paddingBottom: "0" }}>
                        Define Workflow Steps <Super>*</Super>
                      </VendorCardTitle>
                    </Grid>
                  </Grid>
                  {role !== "super admin" ? (
                    <>
                      {" "}
                      <Grid container spacing={2}>
                        <Grid item md={8}>
                          <VendorCardSubTitle style={{ marginTop: "0" }}>
                            Select type of workflow
                          </VendorCardSubTitle>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item md={12}>
                          <RadioGroup
                            value={wfSelection}
                            onChange={handleWfsSelectionChange}
                            row
                          >
                            {/* <FormControlLabel
                              value="manual"
                              control={<Radio />}
                              label={
                                <Typography
                                  variant="body1"
                                  style={{
                                    fontSize: "0.9rem",
                                    fontFamily: "Arial, sans-serif",
                                  }}
                                >
                                  Manual
                                </Typography>
                              }
                            /> */}
                            <FormControlLabel
                              value="predefined"
                              control={<Radio />}
                              label={
                                <Typography
                                  variant="body1"
                                  style={{
                                    fontSize: "0.9rem",
                                    fontFamily: "Arial, sans-serif",
                                  }}
                                >
                                  Pre-defined
                                </Typography>
                              }
                            />
                          </RadioGroup>
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    ""
                  )}
                  {wfSelection === "manual" ? (
                    <>
                      <Grid container spacing={2}>
                        <Grid item md={8}>
                          <VendorCardSubTitle style={{ marginTop: "0" }}>
                            Select how you want to define workflow steps
                          </VendorCardSubTitle>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item md={12}>
                          <RadioGroup
                            value={selection}
                            onChange={handleSelectionChange}
                            row
                          >
                            {/* <FormControlLabel
                            value="role"
                            control={<Radio />}
                            label={
                              <Typography
                                variant="body1"
                                style={{
                                  fontSize: "0.9rem",
                                  fontFamily: "Arial, sans-serif",
                                }}
                              >
                                Role-wise
                              </Typography>
                            }
                          /> */}
                            <FormControlLabel
                              value="person"
                              control={<Radio />}
                              label={
                                <Typography
                                  variant="body1"
                                  style={{
                                    fontSize: "0.9rem",
                                    fontFamily: "Arial, sans-serif",
                                  }}
                                >
                                  Person-wise
                                </Typography>
                              }
                            />
                          </RadioGroup>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item md={8}>
                          <VendorCardSubTitle style={{ marginTop: "0" }}>
                            Select the sequence of the approvers for the
                            workflow
                          </VendorCardSubTitle>
                        </Grid>
                      </Grid>
                      <>
                        <CustomTableContainer component={Card}>
                          <Table aria-label="simple table">
                            <TableHead>
                              <TableRow
                                style={{
                                  backgroundColor: "#e1ebfa",
                                }}
                              >
                                <TableCell
                                  width="10%"
                                  style={{ textAlign: "center" }}
                                >
                                  <TableHeaderFont>Action</TableHeaderFont>
                                </TableCell>
                                <TableCell
                                  width="10%"
                                  style={{ textAlign: "center" }}
                                >
                                  <TableHeaderFont>Step No.</TableHeaderFont>
                                </TableCell>
                                <TableCell
                                  width="20%"
                                  style={{ textAlign: "center" }}
                                >
                                  <TableHeaderFont>
                                    {selection === "person"
                                      ? "Approver"
                                      : "Role"}
                                  </TableHeaderFont>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                          </Table>
                        </CustomTableContainer>
                        <TableBody>
                          {itemswf.map((item, index) => (
                            <TableRow
                              key={index}
                              style={{
                                backgroundColor: "#fafcff",
                              }}
                            >
                              <TableCell width="10%">
                                <CustomButton
                                  className="invoiceErrbutn"
                                  color="error"
                                  variant="outlined"
                                  size="small"
                                  onClick={() => handleRemoveItemWF(index)}
                                  style={{
                                    marginLeft: "3px ",
                                    textAlign: "center",
                                  }}
                                >
                                  Remove
                                </CustomButton>
                              </TableCell>
                              <TableCell
                                style={{
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: "center",
                                }}
                              >
                                {index + 1}
                              </TableCell>
                              <TableCell width="10%">
                                <select
                                  value={
                                    selection === "role"
                                      ? item.role_name
                                      : item.contact_person_email
                                  }
                                  onChange={(e) =>
                                    handleInputChangewf(
                                      index,
                                      selection === "role"
                                        ? "role_name"
                                        : "contact_person_email",
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "5px",
                                    borderRadius: "5px",
                                    fontFamily: "var(--font-family-reg)",
                                    fontSize: "12px",
                                    textAlign: "left",
                                    width: "380px",
                                  }}
                                  required
                                >
                                  <option
                                    value=""
                                    style={{
                                      fontSize: "12px",
                                      color: "#A5A5BA",
                                    }}
                                  >
                                    Select approver
                                  </option>
                                  {item_list_wf.map((item) => (
                                    <option
                                      key={
                                        selection === "role"
                                          ? item.role_name
                                          : item.contact_person_email
                                      }
                                      value={
                                        selection === "role"
                                          ? item.role_name
                                          : item.contact_person_email
                                      }
                                      style={{ fontSize: "12px" }}
                                      disabled={selectedEmails.includes(
                                        selection === "role"
                                          ? item.role_name
                                          : item.contact_person_email,
                                      )}
                                    >
                                      {selection === "role"
                                        ? item.role_name
                                        : item.contact_person_email}
                                    </option>
                                  ))}
                                </select>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                        <CustomButton
                          size="small"
                          color="primary"
                          variant="outlined"
                          onClick={handleAddItemWF}
                          className="invoiceErrbutn"
                          style={{ marginTop: "10px " }}
                        >
                          Add Row
                        </CustomButton>

                        <br />
                        <br />
                        <br />
                      </>
                    </>
                  ) : (
                    <>
                      <Grid container spacing={2}>
                        <Grid item md={8}>
                          <VendorCardSubTitle style={{ marginTop: "0" }}>
                            Select a pre-defined workflow
                          </VendorCardSubTitle>
                        </Grid>
                      </Grid>
                      <Select
                        sx={{
                          fontFamily: "var(--font-family-reg)",
                          fontSize: "14px",
                          width: "100%",
                        }}
                        displayEmpty
                        defaultValue=""
                        IconComponent={() => (
                          <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                        )}
                        labelId="demo-simple-select-standard-label"
                        id="workflow_id"
                        name="workflow_id"
                        error={Boolean(errors?.workflow_id)}
                        {...register("workflow_id", {
                          required: "Please select workflow",
                        })}
                        onChange={(e) => handleOnchange(e)}
                      >
                        <MenuItem value="">
                          <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                            Select workflow
                          </span>
                        </MenuItem>
                        {pr_workflow_details?.map((item, index) => (
                          <MenuItem value={item.id} key={index}>
                            <SelectSpan>{item.name}</SelectSpan>
                          </MenuItem>
                        ))}
                      </Select>
                      <br />
                      <br />
                      <VendorCardTitle>Pre-defined Steps</VendorCardTitle>
                      <CustomTableContainer component={Card}>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow
                              style={{
                                backgroundColor: "#e1ebfa",
                              }}
                            >
                              <TableCell
                                width="10%"
                                style={{ textAlign: "center" }}
                              >
                                <TableHeaderFont>Step No.</TableHeaderFont>
                              </TableCell>
                              <TableCell
                                width="20%"
                                style={{ textAlign: "center" }}
                              >
                                <TableHeaderFont>Name</TableHeaderFont>
                              </TableCell>
                              <TableCell
                                width="20%"
                                style={{ textAlign: "center" }}
                              >
                                <TableHeaderFont>Email</TableHeaderFont>
                              </TableCell>
                              <TableCell
                                width="20%"
                                style={{ textAlign: "center" }}
                              >
                                <TableHeaderFont>Department</TableHeaderFont>
                              </TableCell>
                              <TableCell
                                width="20%"
                                style={{ textAlign: "center" }}
                              >
                                <TableHeaderFont>Role</TableHeaderFont>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {preDefinedWorkflowSteps?.length ? (
                              preDefinedWorkflowSteps.map((row, index) => {
                                return (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell
                                      width="10%"
                                      style={{
                                        fontFamily: "var(--font-family-reg)",
                                        fontSize: "12px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {row.step !== null
                                        ? row.step
                                        : "Not Applicable"}
                                    </TableCell>
                                    <TableCell
                                      width="20%"
                                      style={{
                                        fontFamily: "var(--font-family-reg)",
                                        fontSize: "12px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {row.name !== null
                                        ? row.name
                                        : "Not Applicable"}
                                    </TableCell>
                                    <TableCell
                                      width="20%"
                                      style={{
                                        fontFamily: "var(--font-family-reg)",
                                        fontSize: "12px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {row.contact_person_email !== null
                                        ? row.contact_person_email
                                        : "Not Applicable"}
                                    </TableCell>
                                    <TableCell
                                      width="20%"
                                      style={{
                                        fontFamily: "var(--font-family-reg)",
                                        fontSize: "12px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {row.department !== null
                                        ? row.department
                                        : "Not Applicable"}
                                    </TableCell>
                                    <TableCell
                                      width="20%"
                                      style={{
                                        fontFamily: "var(--font-family-reg)",
                                        fontSize: "12px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {row.role_name !== null
                                        ? row.role_name
                                        : "Not Applicable"}
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow></TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </CustomTableContainer>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </CardContent>
          </StyledCard>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              pt: 2,
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ flex: "1 1 auto" }} />

            {/* <LoadingButton
              size="small"
              color="secondary"
              onClick={handleClick}
              loading={loading}
              loadingPosition="start"
              variant="contained"
            >
              Validate
            </LoadingButton> */}
            <LoadingButton
              sx={{
                textTransform: "none",
                background: "#4059e5",
                width: "200px",
                height: "40px",
              }}
              color="primary"
              variant="contained"
              type="submit"
              loading={loading}
              loadingPosition="start"
              disabled={
                // items[0]?.quantity === 0 ||
                (items.length !== 0 &&
                  items?.find(
                    (item) => item.quantity === 0 || item.quantity === "",
                  )) ||
                items.length === 0 ||
                (wfSelection === "manual" && itemswf.length === 0) ||
                // based of selection value, neither role_name or contact_person_email should be empty
                (wfSelection === "manual" &&
                  selection === "role" &&
                  itemswf.length !== 0 &&
                  itemswf?.find((item) => item.role_name === "")) ||
                (wfSelection === "manual" &&
                  selection === "person" &&
                  itemswf.length !== 0 &&
                  itemswf?.find((item) => item.contact_person_email === "")) ||
                (wfSelection === "predefined" &&
                  preDefinedWorkflowSteps.length === 0)
              }
            >
              Submit
            </LoadingButton>
          </Box>
        </form>
      )}
    </>
  );
}

export default AdminEditPrsContent;
